import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  Inject,
  ViewChild,
  inject,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { MAT_BOTTOM_SHEET_DATA, MatBottomSheetRef } from '@angular/material/bottom-sheet';
import { DomSanitizer, SafeHtml, SafeUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-notification-details-bottom-sheet',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './notification-details.bottom-sheet.html',
  styleUrl: './notification-details.bottom-sheet.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NotificationDetailsBottomSheetComponent {
  @ViewChild('sheetBody', { static: true })
  public sheetBodyRef!: ElementRef<HTMLDivElement>;

  private readonly bottomSheetRef =
    inject(MatBottomSheetRef<NotificationDetailsBottomSheetComponent>);
  private readonly sanitizer = inject(DomSanitizer);
  private readonly hostElement = inject(ElementRef<HTMLElement>);

  private touchStartY = 0;
  private currentTranslateY = 0;
  private isPullingSheet = false;

  public readonly sanitizedBody: SafeHtml;
  public readonly imageUrlSafe: SafeUrl | null;

  public constructor(
    @Inject(MAT_BOTTOM_SHEET_DATA) public readonly data: any,
  ) {
    this.sanitizedBody = this.sanitizer.bypassSecurityTrustHtml(
      data?.body ?? '',
    );

    this.imageUrlSafe = data?.image
      ? this.sanitizer.bypassSecurityTrustUrl(data.image)
      : null;
  }

  public close(): void {
    this.resetTranslate();
    this.bottomSheetRef.dismiss();
  }

  public onTouchStart(event: TouchEvent): void {
    const scrollTop = this.sheetBodyRef?.nativeElement?.scrollTop ?? 0;
    this.touchStartY = event.touches[0]?.clientY ?? 0;
    this.isPullingSheet = scrollTop <= 0;
  }

  public onTouchMove(event: TouchEvent): void {
    if (!this.isPullingSheet) {
      return;
    }

    const currentY = event.touches[0]?.clientY ?? 0;
    const deltaY = Math.max(0, currentY - this.touchStartY);

    this.currentTranslateY = deltaY;
    this.hostElement.nativeElement.style.transform = `translateY(${deltaY}px)`;
  }

  public onTouchEnd(): void {
    if (!this.isPullingSheet) {
      return;
    }

    if (this.currentTranslateY > 90) {
      this.close();
      return;
    }

    this.resetTranslate();
  }

  private resetTranslate(): void {
    this.currentTranslateY = 0;
    this.hostElement.nativeElement.style.transform = '';
  }
}
